import * as types from 'constants/ActionTypes';
import { MODELS_URL } from 'constants/ApiConstants';

// VARIANT
export const fetchVariant = ({ modelId, derivativeCode, variantCode, tvaCode, params }, meta = {}) => ({
  type: types.FETCH_VARIANT_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${MODELS_URL}/${modelId}/derivatives/${derivativeCode}/variants/${variantCode}/tva/${tvaCode}`,
      params,
    },
  },
  meta: {
    modelId,
    derivativeCode,
    variantCode,
    ...meta,
  },
});

export const fetchVariantFailure = error => ({
  type: types.FETCH_VARIANT_FAILURE,
  error,
});

export const fetchVariantSuccess = (variant, modelId, derivativeCode, variantCode) => ({
  type: types.FETCH_VARIANT_SUCCESS,
  variant,
  modelId,
  derivativeCode,
  variantCode,
});

export const fetchVariantMutex = ({ modelId, derivativeCode, variantCode, params }, meta = {}) => ({
  type: types.FETCH_VARIANT_MUTEX_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${MODELS_URL}/${modelId}/derivatives/${derivativeCode}/variants/${variantCode}/exclusions/inverse`,
      params,
    },
  },
  meta: {
    modelId,
    derivativeCode,
    variantCode,
    ...meta,
  },
});

export const fetchVariantMutexFailure = error => ({
  type: types.FETCH_VARIANT_MUTEX_FAILURE,
  payload: error,
  error: true,
});

export const fetchVariantMutexSuccess = (exclusions, variantCode) => ({
  type: types.FETCH_VARIANT_MUTEX_SUCCESS,
  payload: { exclusions },
  meta: {
    variantCode,
  },
});

export const setCategoryAsSeen = code => ({
  type: types.SET_CATEGORY_AS_SEEN,
  code,
});

export const cleanVariant = () => ({
  type: types.CLEAN_VARIANT,
});
